module.exports = require("./../../_gen/starling/assets/AssetReference");


//////////////////
// WEBPACK FOOTER
// ./lib/starling/assets/AssetReference.js
// module id = 149
// module chunks = 0